@if (visible()) {
<div class="floating-panel" [@zoomInOut]="true">
  @if (!icon()) {
  <av-spinner size="lg"></av-spinner>
  } @if (!!icon()) {
  <av-icon mode="light" [class]="cssClass()" [name]="icon()"></av-icon>
  } @if (!!message()) {
  <div class="floating-panel-message" aria-hidden="true">
    {{ message() | translate }}
  </div>
  }
</div>
} @if (backdropVisible()) {
<div class="floating-backdrop" [@fadeOut]="true"></div>
}
@if (prompt(); as p) {
<av-modal-container>
  <av-card
    class="activity-prompt"
    [backdrop]="false"
    role="alertdialog"
    [attr.aria-label]="p.title | translate"
    avTrapFocus
    tabindex="0"
  >
    <av-card-body>
      <div class="text-center">
        @if (p.kind === "popup-blocked") {
        <img
          src="/modules/shared/assets/images/desktop-popup-block.png"
          alt="{{ p.title | translate }}"
        />
        }
        <h3>{{ p.title | translate }}</h3>
        <p [innerHTML]="p.body | translate"></p>
      </div>
    </av-card-body>
    <av-card-footer>
      <button
        avButton
        color="accent"
        size="block"
        [raised]="true"
        (click)="retry()"
        data-tid="activity-indicator/prompt-retry"
      >
        <span translate>Retry</span>
      </button>
    </av-card-footer>
  </av-card>
</av-modal-container>
}
